import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from "react-query";

// Devtools to monitor our data fetched
import { ReactQueryDevtools } from "react-query/devtools";


// React Query Config
const queryClient = new QueryClient(); // Global Store Instance

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   // Provide access to Global Store
   <QueryClientProvider client={queryClient}>
  <React.StrictMode>
    <App />
  </React.StrictMode>

     {/* DevTools Setup */}
     <ReactQueryDevtools initialIsOpen={false} />
     </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
